import type { Saga } from "redux-saga";
import {
  call, put, takeEvery,
} from "redux-saga/effects";
import { setTableData, changeTableItemsTotalAmount, addNotification, type Sorting } from "@fas/ui-framework";
import { GET_ACCOUNT_LIST_SAGA, ACCOUNT_LIST } from "../../helpers/constants";
import { getAccountList } from "../../services/accountApi/account";
import setLoading from "../../actions/loading";
import type { AccountListLoadingTypes as LoadingTypes } from "../../actions/loading";
import type { GetAccountListSaga } from "../../actions/accountList/actions";
import type { Account } from "../../pages/EditAccount";

export function* makeFetch(action: GetAccountListSaga) {
  const { filters } = action;
  try {
    yield put(setLoading<LoadingTypes>(ACCOUNT_LIST, true));

    const page: number = 1;
    const pageSize: number = 50;
    const sorting: Sorting = { name: "desc" };

    const response: {
      data: {
        data: {
          accountsList: Array<Account>,
          count: number,
        },
      }
    } = yield call(getAccountList, {
      page, pageSize, filters, sorting,
    });
    const { data: { accountsList, count } } = response.data;

    yield put(setTableData(ACCOUNT_LIST, accountsList));
    yield put(changeTableItemsTotalAmount(ACCOUNT_LIST, count));
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to fetch account list", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
    yield put(setTableData(ACCOUNT_LIST, []));
  }
  finally {
    yield put(setLoading<LoadingTypes>(ACCOUNT_LIST, false));
  }
}

export default function* getAccountListSaga() {
  yield takeEvery(GET_ACCOUNT_LIST_SAGA, makeFetch);
}
